// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"1c850048","130":"6f92ff0f","236":"d6b0c284","338":"b84a38cb","375":"bf3f42ec","420":"004903f6","532":"438c85c1","681":"a27cac67","852":"a4cd0760","972":"b85e76f6"}[chunkId] + ".chunk.css";
};